const HonestyProvinceMge = r => require.ensure([], () => r(require('@/page/HonestyProvince/HonestyProvinceMge')), 'HonestyProvinceMge');
const HonestyProvinceRelease = r => require.ensure([], () => r(require('@/page/HonestyProvince/HonestyProvinceRelease/HonestyProvinceRelease')), 'HonestyProvinceRelease');
const HonestyProvinceAcceptance = r => require.ensure([], () => r(require('@/page/HonestyProvince/HonestyProvinceAcceptance/HonestyProvinceAcceptance')), 'HonestyProvinceAcceptance');
const HonestyProvincExamine = r => require.ensure([], () => r(require('@/page/HonestyProvince/HonestyProvincExamine/HonestyProvincExamine')), 'HonestyProvincExamine');

const HonestyProvinceRouter = {
  path: '',
  component: HonestyProvinceMge,
  meta: {
    icon: 'organMge',
    right: [],
    isShowMenu: true,
  },
  name: '出省诚信证明申请',
  redirect: '/HonestyProvinceMge',
  children: [{
    path: '/HonestyProvinceRelease',
    component: HonestyProvinceRelease,
    name: '出省诚信证明申请',
    meta: {
      right: [],
      isShowMenu: false,
      workTemplateName: '出省经营诚信证明',
      keepAlive:true,
    },
  }, {
    path: '/Honestyssdsda',
    name: '出省诚信证明申请',
    meta: {
      right: [],
      workflow: true,
      isShowMenu: true,
      workTemplateName: '出省经营诚信证明',
      keepAlive:true,
    },
  }, {
    path: '/HonestyProvinceAcceptance',
    component: HonestyProvinceAcceptance,
    name: '出省诚信证明受理',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  }, {
    path: '/HonestyProvincExamine',
    component: HonestyProvincExamine,
    name: '出省诚信证明审核',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  }, ]
};

export default HonestyProvinceRouter;